<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
    const ProgramaModelo = defineAsyncComponent(() => import('../components/oferta/ProgramaModelo.vue')); 
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'));
const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) ;
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const LicExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/LicExcelenciaAcadem.vue')) ; 
    // const CasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
    
</script>

<template>
    <TopBannerLeft :img="'background-image: url(../../pagesImages/derecho.jpg);'" :nivel="'Licenciatura en'" :carrera="'Derecho'" :frase="'Una cosa no es justa por el hecho de ser ley. Debe ser ley porque es justa'" :autor="'Montesquieu'"/>
    <FormarBloque :img="'../../pagesImages/derecho-ejecutivo.jpg'" alt="Licenciado en Derecho Universidad Humanitas" :link="'/requisitos-licenciatura'" :frase="'Expertos en el conocimiento, análisis y aplicación de las normas jurídicas'" :testo1="'Formamos profesionistas con un profundo conocimiento del Derecho, capacitados para analizar, interpretar y aplicar las normas jurídicas con el propósito de regular y armonizar las relaciones sociales y económicas entre el Estado, los ciudadanos y las instituciones.'" :testo2="'Nuestro enfoque académico fomenta valores fundamentales como el orden, la seguridad, la justicia y la libertad, pilares esenciales para el desarrollo de una sociedad equitativa y funcional.'" :testo3="'Este programa está dirigido a quienes tienen interés en comprender la estructura jurídica del Estado, la interacción entre sus órganos y la ciudadanía, así como los mecanismos legales que garantizan el ejercicio de los derechos y el cumplimiento de las obligaciones dentro de un marco normativo sólido.'"/>
    <div class="flex items-center justify-center mb-12">
    </div>
    <ProgramaModelo :ejecutivo="true" :escolarizado="true" :virtual="true"/>
    <VerModelo esco="/pagesImages/Programas/Licenciatura/Escolarizado/lic-derecho-escolarizado.webp"
    ejec="/pagesImages/Programas/Licenciatura/lic-derecho-ejecutivo.webp"
    virt="/pagesImages/Programas/Licenciatura/lic-derecho-ejecutivo.webp"
    :escoT="true"
    :ejecT="true"
    :virtT="true" />
    <CalendarioOferta nombre="Licenciatura en Derecho" :titulo="'Calendario de la licenciatura Escolarizada'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, false, false, true, true, false, false]"></CalendarioOferta>
    <CalendarioOferta nombre="Licenciatura en Derecho" :titulo="'Calendario de la licenciatura Ejecutiva'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, true, true, true, true, true, true]"></CalendarioOferta>
    <!-- <DescargaFolleto :esco="'/assets/lic-admin-esco.pdf'" :escoT="true" :ejec="'/assets/lic-admin-ejec.pdf'" :ejecT="true" :virt="'/assets/lic-admin-virt.pdf'" :virtT="true"/> -->
    <!-- <LicExcelenciaAcadem />
    <CasosExito /> -->
    <EgresadosHuma :types="'Licenciatura Dere'" class="mb-16" />
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Campus Humanitas que </span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">cuentan con esta licenciatura</span>
                        </h2>
                        <div class="grid grid-cols-2 justify-center w-auto">
                            <ul class="list-disc pl-8 mb-4 ">
                                <li>Cancún</li>
                                <li>Chihuahua</li>
                                <li>Del Valle</li>
                                <li>Guadalajara</li>
                                <li>Presa Madín</li>
                                <li>Reyes</li>
                                <!-- <li>Tijuana</li> -->
                            </ul>
                            <ul class="list-disc mb-4">
                                <li>Tijuana</li>
                                <li>Virtual</li>
                                <li>Mérida</li>
                                <li>Monterrey</li>
                                <li>Querétaro</li>
                                <li>Santa Fe</li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/fachada-campus-madin.webp" alt="Imagen de fachada de Campus Madín" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
    </section>
    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/licenciaturas-estructura.webp" alt="Estructura académica en Universidad Humanita" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques temáticos):</span>
                        </h2>
                        <ul class="list-disc pl-3 hyphens-auto">
                            <li><b>Fundamentos del Derecho y Teoría Jurídica:</b> Introducción al estudio del Derecho, instituciones del Derecho Romano, argumentación jurídica y teoría general del proceso.</li>
                            <li><b>Derecho Civil:</b> Derecho Civil I, II, III, IV, V y VI, Derecho penal I, II, III, Derecho Procesal Penal I y II.</li>
                            <li><b>Derecho Constitucional:</b> I, II y III, Derecho procesal Constitucional I, II, III y IV.</li>
                            <li><b>Derecho Laboral:</b> I, II, procesal laboral.</li>
                            <li><b>Derecho Mercantil:</b> I, II y III.</li>
                            <li><b>Derecho Procesal Civil:</b> I, II y III.</li>
                            <li><b>Derecho Administrativo:</b> I y II, Procesal administrativo y II.</li>
                            <li><b>Derecho Fiscal e Internacional:</b> I, II, III y IV, Internacional público y privado.</li>
                            <li><b>Talleres y Seminarios de Profesionalización:</b> Taller profesional I, II, III, IV y V, seminario de desarrollo profesional I, II, III, IV y V.</li>
                            <li><b>Idiomas:</b> Inglés I, II, III, IV, V, VI, VII, VIII. Solo en modelo escolarizado.</li>
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</section>
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <PoliticaIA />
</template>

<style scoped>
</style>